import { buildModule } from '../utils';

import messaging from './messaging';
import role from './role';
import file from './file';

export default buildModule()
	.withSubmodules({
		messaging,
		role,
		file,
	})
	.withState({
		globalError: null as number | null,
	})
	.withGetters({
		globalError: state => state.globalError,
	})
	.withMutations({
		GLOBAL_ERROR (state, status: number | null) {
			state.globalError = status;
		},
	});
